export default "__VITE_ASSET__C_2VFPKA__"